import { PUBLICATION_SEARCH_KEY } from "@/config/query-parameter-consts";

// If a publication id is present use the publication api endpoint. (needed for publication sharing)
export const getSearchStatePublicationId = () =>
  new URLSearchParams(window.location.search).get(PUBLICATION_SEARCH_KEY);
